module.exports = __webpack_public_path__ + "img/violet_103.758e3f8e.png";